/**
 * useFollow Hook (Web)
 * Thin wrapper around shared useFollow
 */

import { useAuth } from '@contexts/AuthContext';
import { createHttpClient } from '@parlay-picker/shared/api/httpClient';
import { type UseFollowResult, useFollow as useFollowShared } from '@parlay-picker/shared/hooks';
import { useMemo } from 'react';
import { API_BASE_URL } from '../config/api';

export type { UseFollowResult };

export function useFollow(targetUserId: string): UseFollowResult {
  const { isAuthenticated, authFetch } = useAuth();

  const httpClient = useMemo(
    () => createHttpClient({ authFetch, baseUrl: API_BASE_URL }),
    [authFetch],
  );

  return useFollowShared({
    httpClient,
    targetUserId,
    isAuthenticated,
  });
}
